var _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGriegConnect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 251.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grieg-connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.12,142.5v-4.58h-6.8v-9.77H88v20.68c-4.73,4.35-10.76,6.26-17.25,6.26-14.65,0-23.81-9.92-23.81-24,0-14.73,10.15-24.35,25-24.35a25.75,25.75,0,0,1,13.58,3.67v11.9A22.22,22.22,0,0,0,71.93,118c-7.48,0-12.75,5-12.75,13.05,0,7.94,4.81,13.13,11.91,13.13A9.94,9.94,0,0,0,77.12,142.5Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.09,138.84v15.49H98V107.47H119c10.07,0,17,5.72,17,16,0,7.1-3.59,12-9.31,14.12l11,16.79H124.13l-9.77-15.49Zm0-9.77h7.63c4.35,0,6.34-2.22,6.34-5.65s-2-5.65-6.34-5.65h-7.63Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.87,154.33H145.58V107.47h12.29Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.21,107.47V118H180.76v7.33h19.62v10.3H180.76v8.09h21.45v10.61h-33.5V107.47Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.53,142.5v-4.58h-6.79v-9.77h17.63v20.68c-4.74,4.35-10.77,6.26-17.25,6.26-14.66,0-23.82-9.92-23.82-24,0-14.73,10.16-24.35,25-24.35a25.75,25.75,0,0,1,13.58,3.67v11.9A22.19,22.19,0,0,0,235.34,118c-7.48,0-12.75,5-12.75,13.05,0,7.94,4.81,13.13,11.91,13.13A9.94,9.94,0,0,0,240.53,142.5Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "226.42 226.42 25.16 226.42 25.16 25.16 250.32 25.16 250.32 0 0 0 0 251.58 251.58 251.58 251.58 166.2 226.42 166.2 226.42 226.42",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.74,106.7a21.13,21.13,0,0,1,11.91,3.21v11.9A17.47,17.47,0,0,0,299.74,118C292,118,287,122.81,287,130.9s5,12.82,12.75,12.82A17.34,17.34,0,0,0,310.65,140v11.91a21.21,21.21,0,0,1-11.91,3.2c-14.27,0-24-9.61-24-24.19S284.47,106.7,298.74,106.7Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M340.8,155.09c-13.51,0-22.82-10.23-22.82-24.19s9.31-24.2,22.82-24.2,23,10.15,23,24.2S354.38,155.09,340.8,155.09Zm0-37.63c-6.34,0-10.46,5.35-10.46,13.44s4.12,13.43,10.46,13.43,10.61-5.34,10.61-13.43S347.13,117.46,340.8,117.46Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M413.31,154.33h-9.92l-19.62-27.4v27.4H371.94V107.47h11.45l18.09,25.79V107.47h11.83Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M464.75,154.33h-9.92l-19.62-27.4v27.4H423.38V107.47h11.45l18.09,25.79V107.47h11.83Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M508.33,107.47V118H486.89v7.33H506.5v10.3H486.89v8.09h21.44v10.61h-33.5V107.47Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M539.7,106.7a21.13,21.13,0,0,1,11.91,3.21v11.9A17.47,17.47,0,0,0,540.7,118c-7.79,0-12.75,4.81-12.75,12.9s5,12.82,12.75,12.82A17.34,17.34,0,0,0,551.61,140v11.91a21.21,21.21,0,0,1-11.91,3.2c-14.27,0-24-9.61-24-24.19S525.43,106.7,539.7,106.7Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M558.78,107.47H600V118H585.5v36.33H573.21V118H558.78Z",
    transform: "translate(0 -0.21)",
    fill: "#ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGriegConnect);
export default __webpack_public_path__ + "static/media/grieg-connect.889799e4b7ab5202f64cc9b88b3c645e.svg";
export { ForwardRef as ReactComponent };